import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { FormatTypes } from 'Lib/Format';

let HandShearVaneResultsSection: React.FC<IWorksheetComponent> = () => {
  return (
    <WorksheetGridFieldSection name="EmbeddedTests.Tests">
      <WorksheetRecordGrid
        name="EmbeddedTests.Tests"
        orientation="horizontal"
        rowHeaderWidth={200}
        recordProps={{
          width: 130,
          heading: 'number',
          headingLabel: 'Test Number',
          preventRemove: true,
          preventCreate: true,
        }}
        fieldSet={[
          {
            name: 'Data.HandShearVane.Results.AverageVaneShearStrengthText',
            label: 'Vane Shear Strength (kPa)',
            component: <Field input={<TextOutput />} />,
          },
          {
            name: 'Data.Results.Exclude',
            component: <Field input={<TextOutput />} format={{ type: FormatTypes.YesNo }} />,
          },
        ]}
      />
    </WorksheetGridFieldSection>
  );
};

HandShearVaneResultsSection = withInjectedProps(HandShearVaneResultsSection);

export { HandShearVaneResultsSection };
export default HandShearVaneResultsSection;
